import { CurriculumSelectorOnChangeCallbackArgs } from '@/components/common/curriculum-selector';
import { EContentType } from '@/store/types';
import { IRecommendedContentsAdmin } from '@/store/types.admin';
import { PayloadAction } from '@reduxjs/toolkit';
import { createSliceSteamup } from '../common';

interface IRecommendedContentsManageState {
  loading: boolean;
  list: IRecommendedContentsAdmin[];

  filter: {
    isMajor: boolean;
    contentType: 'ALL' | EContentType;
    function: 'ALL' | number[];
    tag: 'ALL' | number[];
    curriculum: 'ALL' | CurriculumSelectorOnChangeCallbackArgs;
  }
}

const recommendedContentsManageSlice = createSliceSteamup(
  'recommendedContentsManage',
  {
    loading: true,
    list: [],
    filter: {
      isMajor: false,
      contentType: 'ALL',
      function: 'ALL',
      tag: 'ALL',
      curriculum: 'ALL',
    },
  } as IRecommendedContentsManageState,
  {
    setFilterOfIsMajor(state, { payload }: PayloadAction<(typeof state.filter.isMajor)>) {
      state.filter.isMajor = payload;
    },
    setFilterOfContentType(state, { payload }: PayloadAction<(typeof state.filter.contentType)>) {
      state.filter.contentType = payload;
    },
    setFilterOfCurriculum(state, { payload }: PayloadAction<(typeof state.filter.curriculum)>) {
      state.filter.curriculum = payload;
    },
    setFilterOfKeywordToALL(state, { payload }: PayloadAction<{ group: 'function' | 'tag' }>) {
      state.filter[payload.group] = 'ALL';
    },
    pushFilterOfKeyword(state, { payload }: PayloadAction<{ group: 'function' | 'tag', keyID: number }>) {
      const filterValue = state.filter[payload.group];
      if (filterValue === 'ALL') {
        state.filter[payload.group] = [payload.keyID];
      } else {
        filterValue.push(payload.keyID);
      }
    },
    setFilterOfKeyword(state, { payload }: PayloadAction<{ group: 'function' | 'tag', keyIDs: number[] }>) {
      state.filter[payload.group] = payload.keyIDs;
    },
    removeContent(state, { payload }: PayloadAction<{ id: number }>) {
      const index = state.list.findIndex(({ id }) => id === payload.id);
      if (index > -1) {
        state.list.splice(index, 1);
      }
    },
    swapOrder(state, { payload }: PayloadAction<{ id1: number, id2: number }>) {
      const index1 = state.list.findIndex(({ id }) => id === payload.id1);
      const index2 = state.list.findIndex(({ id }) => id === payload.id2);
      const target1 = state.list[index1];
      const target2 = state.list[index2];
      if (!target1 || !target2) return;
      const temp = target1.order;
      target1.order = target2.order;
      target2.order = temp;
    },
  },
);

export default recommendedContentsManageSlice;
